import CSSModules from 'react-css-modules'
import DateRangePicker from 'components/date-range-picker'
import SingleDatePicker from 'components/single-date-picker'
import React, { PropTypes } from 'react'

import styles from './grid-dates-modal.css'

const GridDatesModal = ({ onDatesChange, onToggleRangeMode, formatDate, dates, range, onContinue }) => (
  <div styleName="content">
    <h1 styleName="title">Add or remove dates</h1>
    <p styleName="description">
      Click to add or remove dates. Running a multi-day event?
      <button styleName="button" onClick={onToggleRangeMode}>Select a date range.</button>
    </p>
    {range ? (
      <DateRangePicker
        dates={dates}
        format={formatDate}
        onChange={onDatesChange}
        onClose={onToggleRangeMode}
      />
    ) : (
      <SingleDatePicker
        dates={dates}
        format={formatDate}
        onChange={onDatesChange}
        onContinue={onContinue}
      />
    )}
  </div>
)

GridDatesModal.propTypes = {
  dates: PropTypes.array.isRequired,
  formatDate: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
  onDatesChange: PropTypes.func.isRequired,
  onToggleRangeMode: PropTypes.func.isRequired,
  range: PropTypes.bool.isRequired,
}

export default CSSModules(GridDatesModal, styles)



/** WEBPACK FOOTER **
 ** ./src/components/grid-dates-modal/grid-dates-modal.js
 **/